import { Button } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";

/** @type {import("framer-motion").Variants} */
const BUTTON_LABELS = {
  hidden: {
    width: 0,
    transition: {
      type: "tween",
      duration: 0.25,
      when: "afterChildren",
    },
  },
  visible: {
    width: "auto",
    transition: {
      type: "tween",
      duration: 0.25,
      when: "beforeChildren",
      delay: 0.25,
    },
  },
};

/** @type {import("framer-motion").Variants} */
const OPACITY_VARIANTS = {
  hidden: {
    opacity: 0,
    transition: {
      type: "tween",
      duration: 0.25,
    },
  },
  visible: {
    opacity: 1,
    transition: {
      type: "tween",
      duration: 0.25,
    },
  },
};

/**
 * @typedef {Object} Props
 * @property {string} label
 *
 * @param {Props & import("@chakra-ui/react").ButtonProps} props
 */
function AnimatedButton({ label, ...props }) {
  return (
    <Button {...props}>
      <AnimatePresence initial={false} exitBeforeEnter={false}>
        <motion.div
          key={label}
          variants={BUTTON_LABELS}
          initial="hidden"
          animate="visible"
          exit="hidden">
          <motion.div variants={OPACITY_VARIANTS}>{label}</motion.div>
        </motion.div>
      </AnimatePresence>
    </Button>
  );
}

export default AnimatedButton;
